<div class="pie-card">
  <div class="pie-header">
    <div>
      <span class="chart-eyebrow">Financeiro</span>
      <h2 class="chart-title">Despesas por Grupo e Subgrupo</h2>
      <p class="chart-subtitle">Distribuição percentual de gastos no período mensal</p>
      <span class="chart-periodo">Período: {{ dataInicial }} a {{ dataFinal }}</span>
    </div>
    <button class="btn btn-outline-secondary btn-sm" type="button"
            (click)="carregarDados()" [disabled]="isLoading">
      Atualizar
    </button>
  </div>

  <div *ngIf="isLoading" class="state-box">
    <div class="spinner-border text-primary" role="status"></div>
    <span>Carregando despesas...</span>
  </div>

  <div *ngIf="hasError && !isLoading" class="state-box error">
    <span>Não foi possível carregar as despesas mensais.</span>
    <button class="btn btn-primary btn-sm" type="button" (click)="carregarDados()">Tentar novamente</button>
  </div>

  <div *ngIf="!isLoading && !hasError && grupos.length === 0" class="state-box">
    <span class="text-muted">Nenhuma despesa encontrada para o período.</span>
  </div>

  <div *ngIf="!isLoading && !hasError && grupos.length > 0" class="charts-grid">

    <!-- ── Donut: gastos por grupo ───────────────────────────── -->
    <div class="chart-panel">
      <h3 class="panel-title">Por Grupo</h3>

      <div class="donut-wrap">
        <svg viewBox="0 0 200 200" class="donut-svg">
          <path *ngFor="let g of grupos"
                [attr.d]="g.slicePath"
                [attr.fill]="g.color"
                [attr.opacity]="tooltipGrupo && tooltipGrupo.grupo !== g.grupo ? 0.4 : 1"
                class="donut-slice"
                (mouseenter)="showTooltip(g)"
                (mouseleave)="hideTooltip()">
          </path>
          <text x="100" y="95"  class="donut-center-label">Total</text>
          <text x="100" y="115" class="donut-center-value">
            {{ totalGeral | currency:'BRL':'symbol':'1.0-0' }}
          </text>
        </svg>

        <div class="donut-tooltip" *ngIf="tooltipGrupo">
          <div class="tooltip-grupo" [style.color]="tooltipGrupo.color">
            {{ tooltipGrupo.grupo }}
          </div>
          <div class="tooltip-row">
            <span>Valor:</span>
            <strong>{{ tooltipGrupo.valorPago | currency:'BRL' }}</strong>
          </div>
          <div class="tooltip-row">
            <span>% do total:</span>
            <strong>{{ tooltipGrupo.pctDoTotalGeral | number:'1.1-1' }}%</strong>
          </div>
        </div>
      </div>

      <div class="donut-legend">
        <div *ngFor="let g of grupos" class="legend-item">
          <span class="legend-dot" [style.background]="g.color"></span>
          <span class="legend-label">{{ g.grupo }}</span>
          <span class="legend-pct">{{ g.pctDoTotalGeral | number:'1.1-1' }}%</span>
        </div>
      </div>
    </div>

    <!-- ── Barras horizontais: gastos por subgrupo ───────────── -->
    <div class="chart-panel">
      <h3 class="panel-title">Por Subgrupo</h3>

      <div class="bar-list">
        <div *ngFor="let s of subgrupos" class="bar-row">
          <div class="bar-meta">
            <span class="bar-subgrupo">{{ s.subgrupo }}</span>
            <div class="bar-values">
              <span class="bar-valor">{{ s.valorPago | currency:'BRL':'symbol':'1.0-0' }}</span>
              <span class="bar-pct">{{ s.pctDoTotalGeral | number:'1.1-1' }}%</span>
            </div>
          </div>
          <div class="bar-track">
            <div class="bar-fill"
                 [style.width.%]="s.barWidth"
                 [style.background]="s.color">
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
